import { Component } from '@angular/core';
import {TripService} from 'src/app/services/trip.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { DatePipe } from '@angular/common';

interface Expense {
  date: string;
  vendor: string;
  category: string;
  reference: string;
  amount: number;
}
export interface ExpenseData {
  expenseDate: string;
  merchant: string;
  category: string;
  amount: number;
  currency: string;
  reimbursable: boolean;
  description: string;
  reference: string;
}
@Component({
  selector: 'app-manage-expence',
  templateUrl: './manage-expence.component.html',
  styleUrls: ['./manage-expence.component.css']
})
export class ManageExpenceComponent {

  userUuid:any
  


  expenses: Expense[] = [
    {
      date: '13/11/2020',
      vendor: 'IRCTC',
      category: 'Uncategorized',
      reference: '2541369579',
      amount: 12485.36,
    }
  ];
  selected:any='Home'
  menuItems = [
    { label: 'Home', icon: 'home' },
    { label: 'Trips', icon: 'event' },
    { label: 'Expenses', icon: 'credit_card' },
    { label: 'Reports', icon: 'description' },
    { label: 'Advances', icon: 'account_balance_wallet' },
    // { label: 'Cards', icon: 'credit_card' },
    { label: 'Approvals', icon: 'check_circle' },
    // { label: 'Analytics', icon: 'bar_chart' },
    // { label: 'Settings', icon: 'settings' },
  ];
  activeTab(item:any){
this.selected=item
// if(this.selected==='Expenses'){
//   this.openPopup()

// }
this.getReportList()
  }

  displayDialog: boolean = false;
  tripOptions = [
    { label: 'Business', value: 'business' },
    { label: 'Leisure', value: 'leisure' },
  ];
  constructor(private ToastmsgService:ToastmsgService,private TripService:TripService,private userInfoService:UserInfoService){
    this.userUuid=this.userInfoService.getUserUuid()

this.getActiveTripList()
  }


  tripResponse:any
  getActiveTripList(){
    this.TripService
    .getActiveTrip( this.userUuid)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.tripResponse={
            tripName:data?.tripName,
            tripUid:data?.tripUid
          }

          this.getReportList()

         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}



  showDialog() {
    this.action='new'

    this.displayDialog = true;
    this.reportRequest={
      reportName:'',
      businessPurpose:'',
      tripId:'',
      fromDate:new Date().toISOString().slice(0, 10),
      toDate:new Date().toISOString().slice(0, 10)
      
    }
  }

  save() {
    // Save logic here
    this.displayDialog = false;
  }

  cancel() {
    this.displayDialog = false;
  }


  isOpen = false;
  selectedReport = '';
  displayedColumns: string[] = ['index', 'expenseDate', 'merchant', 'category', 'amount', 'reimbursable'];
  datasource: ExpenseData[] = [
      { expenseDate: '', merchant: '', category: 'none', amount: 0, currency: 'INR', reimbursable: true, description: '', reference: '' }
  ];

  expenseRequest:any={
    merchant:'',
     expenseDate:new Date().toISOString().slice(0, 10), 
     category:'', 
     description:'',
      amount:'',
       reportId:'',
        reimburasble:false,
         reference:''
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }
actionE:any
rowExpenseClick(item:any){
  this.actionE='update'
  this.expenseRequest={
    merchant:item?.merchant,
     expenseDate:item?.expenseDate, 
     category:item?.category, 
     description:item?.description,
      amount:item?.amount,
       reportId:item?.reportId,
        reimburasble:item.reimburasble,
         reference:item?.reference
  }
  this.isOpen=true

}
disableExpanse(){
if(this.expenseRequest.category&&this.expenseRequest.amount&&this.expenseRequest.merchant){
return false
}
return true
}
  openPopup() {
    this.actionE='new'
    this.expenseRequest={
      merchant:'',
       expenseDate:new Date().toISOString().slice(0, 10), 
       category:'', 
       description:'',
        amount:'',
         reportId:this.selectedReport,
          reimburasble:false,
           reference:''
    }
    this.isOpen = true;
}

closePopup() {
    this.isOpen = false;
}

addExpense() {
    this.datasource.push({ expenseDate: '', merchant: '', category: 'none', amount: 0, currency: 'INR', reimbursable: true, description: '', reference: '' });
this.selected=false

setTimeout(() => {
  this.selected='Expenses'

}, 5);
  }

  onClickExpense(){
    this.selected='Expenses'
  }
  reportRequest:any={
    reportName:'',
    businessPurpose:'',
    tripId:'',
    fromDate:new Date().toISOString().slice(0, 10),
    toDate:new Date().toISOString().slice(0, 10)
    
  }
  disableReport(){
    if(this.reportRequest?.reportName&&this.reportRequest.fromDate&&this.reportRequest.toDate &&this.reportRequest.tripId){
return false
    }
    return true
  }
action:any
  rowReportClick(item:any){
// this.action='update'
//     this.displayDialog = true;
//     this.reportRequest={
//       reportName:item?.reportName,
//       businessPurpose:item?.businessPurpose,
//       tripId:item?.tripId,
//       fromDate:item?.fromDate,
//       toDate:item?.toDate
      
//     }
this.getReportList()

this.selectedReport=item?.reportUid

this.selected='Expenses'
this.getExpenseList()
  }
  AddReport() {
    this.TripService.saveReport(this.reportRequest)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.ToastmsgService.setMsg({msg : "Report Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.getReportList()
           this.displayDialog = false;
           this.isOpen = false;


          } else {
            const body : any = res.body;
            this.registerGroupErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerGroupErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerGroupErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.ToastmsgService.setMsg({msg : "Failed to save Report",msgTitle : "Warning", msgType : "W"});
    } else {

      this.ToastmsgService.setMsg({msg : "Failed to save Report",msgTitle:  "Warning", msgType : "W"});
    } 
  }
reportList:any=[]
  getReportList(){
    this.TripService
    .getReportList(this.tripResponse.tripUid)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.reportList=data
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}

    formatDate(val: Date) {
      let convertedValue:any = ""
      if(val){
      let datepipe = new DatePipe("en");
      //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
      convertedValue =  datepipe.transform(val, "yyyy-MM-dd");
      }
      return convertedValue;
    }

    AddExpense() {
      this.TripService.saveExpanse(this.expenseRequest)
        .subscribe({
          next : (res) => {
            if(res.status==200 || res.status==201) {
              this.ToastmsgService.setMsg({msg : "Expense Added Successfully!",msgTitle : "Success", msgType : "I"});
             // this.router.navigate(["/sign-in"]);
            //  this.getReportList()
             this.isOpen = false;
         this.getExpenseList()
            } else {
              const body : any = res.body;
              this.ToastmsgService.setMsg({msg : "Failed to save Expense",msgTitle:  "Warning", msgType : "W"});
            } 
  
          },error : (err) => {
  
            this.ToastmsgService.setMsg({msg : "Failed to save Expense",msgTitle:  "Warning", msgType : "W"});
          }
        }
      )
    }


    sendApproval() {
      this.TripService.Send(this.selectedReport)
        .subscribe({
          next : (res) => {
            if( res) {
              this.ToastmsgService.setMsg({msg : "Approval Request Sent !",msgTitle : "Success", msgType : "I"});
             // this.router.navigate(["/sign-in"]);
            //  this.getReportList()
             this.isOpen = false;
         this.getExpenseList()
            } else {
              this.ToastmsgService.setMsg({msg : "Failed to approve",msgTitle:  "Warning", msgType : "W"});
            } 
  
          },error : (err) => {
  
            this.ToastmsgService.setMsg({msg : "Failed to approve",msgTitle:  "Warning", msgType : "W"});
          }
        }
      )
    }

    expenseList:any=[]
    categoryList:any=['Mobile Bill','Broadband Reimbursement','Food Expenses','Local Expenses','Laptop Bag','Sales Conveyance','Company Confidential']
  getExpenseList(){
    this.TripService
    .getExpanseList(this.selectedReport)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          this.expenseList=data
         } else {

         } 
      },error : (err) => {

        console.error("Error in fetching result");
      }
    })}
}
